<template>
	<div class="block-space--layout--divider-20" v-if="totalItems > 0"></div>
	<div class="card mb-lg-0" v-if="totalItems > 0" >
		<div class="card-body card-body--padding--1">
			<h3 class="card-title">Shipping Details from {{ currentLocationDetails.locationcity }}</h3>
			<products-ordered :currentlocationid="currentlocationid"></products-ordered>
			<div class="block-space block-space--layout--divider-thin"></div>
			<div class="form-group">
				<div class="form-group col-md-6">
					<label for="checkout-first-name">Shipping From:</label>
					<p><strong>{{ currentLocationDetails.locationname }}</strong><br> {{ currentLocationDetails.locationcity }}, {{ currentLocationDetails.locationstate }} </p>
				</div>
				<!-- <div class="form-group col-md-6">
					<label for="checkout-first-name">Ship To:</label>
					<p><strong>{{ name }}</strong><br>
					{{ fullAddress }}<br>
						{{ city }}, {{ state }} {{ zip }}</p>
				</div> -->
			</div>
			<div class="form-group">
				<label for="checkout-country">Select Shipping Method</label><label class="required-field" >*</label>
				<select id="checkout-shipping-method" class="form-control" v-model="shippingcarrier" @change="upShippingRate($event)">
					<option value="">Choose an Option </option>
					<option v-for="carrier in carrierlist" :key="carrier.carriercode" :value="carrier.carriercode" :rate="carrier.carrier_rate">{{ carrier.carriername }}</option>
				</select>
			</div>
			
		</div>
		<div class="card-divider"></div>
		<div class="card-body card-body--padding--1" v-if="backorderedItems.length > 0">
			<h5 class="card-title">Products on Backorder from {{ currentLocationDetails.locationcity }}</h5>
			<table class="checkout__totals">
				<thead class="checkout__totals-header">
					<tr>
						<th>Summary</th>
						<th>Amount</th>
						<th>Line Items</th>
					</tr>
				</thead>
				<tbody class="checkout__totals-products">											                                          
					<tr>
						<td><strong>Backordered:</strong></td>
						<td>{{ backorderedTotal }}</td>
						<td>{{ backorderedQty }}</td>
					</tr>
				</tbody>
			</table>
			<div class="widget widget-filters--offcanvas--mobile-bg-color" data-collapse data-collapse-opened-class="filter--opened">
				<div class="widget-filters__item">
					<div class="filter" :class="classBOContentClass">
						<button type="button" class="filter__title filter__title--backordered" @click="showBO = !showBO">
							BACKORDERED ITEMS (Click to Expand)
							<span class="filter__arrow">
								<svg width="12px" height="7px">
								<path d="M0.286,0.273 L0.286,0.273 C-0.070,0.629 -0.075,1.204 0.276,1.565 L5.516,6.993 L10.757,1.565 C11.108,1.204 11.103,0.629 10.747,0.273 L10.747,0.273 C10.385,-0.089 9.796,-0.086 9.437,0.279 L5.516,4.296 L1.596,0.279 C1.237,-0.086 0.648,-0.089 0.286,0.273 Z" />
								</svg>
							</span>
						</button>
						<div class="filter__body" data-collapse-content>
							<div class="filter__container">
								<div class="block-space--layout--divider-15"></div>									
								<table class="checkout__totals">
									<thead class="checkout__totals-header">
										<tr>
											<th class="text-currently-unavailable">Backordered Items</th>
											<th class="checkout-summary-qty--head">QTY</th>
											<th>AMOUNT</th>
										</tr>
									</thead>
									<tbody class="checkout__totals-products">
										<tr v-for="item in backorderedItems" :key="item.linenumber">
										<td>
											<strong>{{ item.desc }}</strong><br>
											<small style="margin-right: 10px">Item: {{ item.ID }}</small>
											<small>MFR: {{ item.manufacturer }}</small><br>												  
										</td>
											<td class="checkout-summary-qty"><div class="checkout-summary-qty"> {{ item.quantity }}</div></td>
											<td>{{ toUSD(item.linetotal) }}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>									
		</div>
									
	</div>
</template>

<script>
import ProductsOrdered from './ProductsOrdered'; 
// import axiosvl from "../../../axios/axios-vl.js";
import Price from '../../../mixins/price.js';
import { mapGetters } from 'vuex';

export default {
    components: {
        "products-ordered": ProductsOrdered   
    },
	mixins: [Price],
    props: {
		carrierlist : {
            type: Array,
        },
        currentlocationid: {
            type: String,
            required: true
        },
        name: {
            type: String
        },
        address1: {
            type: String
        },
        address2: {
            type: String
        },
        city: {
            type: String
        },
        state: {
            type: String
        },
        zip: {
            type: String
        },
        country: {
            type: String
        },
        phone: {
        },
        email: {
            type: String
        },
		defaultcarrier: {
			type: String
		}
    },
	data() {
		return {
			differentaddress: false,
			shippingname: '',
			shippingaddress: '',
			shippingstate: '',
			shippingzip: '',
			shippingcountry: 'USA',
			shippingcarrier: '',
			// carrierlist: [],
			ordernotes: '',
			showBO : false,
		}
	},
    computed: {
        fullAddress() {
            if (this.address1 === '') {
                return this.address2;
            } else {
                return this.address1 + ' ' + this.address2
            }
        },
		...mapGetters("cart", [
            "cart",
            "totals",
			"carrier"
        ]),
		...mapGetters([
            'storefrontAttributes',
            "getDefaultLocationDetails",
			"customerIndicator"
        ]),
        currentLocationDetails() {
            let current = this.cart.find((item) => item.locationid === this.currentlocationid);
			// console.log(this.cart);
			// console.log(current);
			// console.log(this.currentlocationid);
			// console.log(this.getDefaultLocationDetails.defaultlocationid);

            if (current === undefined && this.currentlocationid === this.getDefaultLocationDetails.defaultlocationid) {
                // Try to get the default location instead
                current = {
                    "locationid": this.getDefaultLocationDetails.defaultlocationid,
                    "locationname": this.getDefaultLocationDetails.defaultlocationname,
                    "locationcity": this.getDefaultLocationDetails.defaultlocationcity,
                    "locationstate": this.getDefaultLocationDetails.defaultlocationstate
                }
            }

			// console.log(current);

            return current;
        },

		/**
		 * filter the items on the cart by
		 * location id and as tagged as back order item
		 */
		backorderedItems() {
            const bo_items = this.cart.filter(item => {
                if (this.currentlocationid === this.getDefaultLocationDetails.defaultlocationid) {
                    return (item.locationid === undefined || item.locationid === this.currentlocationid) && item.backorder;
                } else {
                    return (item.locationid === this.currentlocationid) && item.backorder;
                }
            });
			
			return bo_items;
        },

		/**
		 * return total of backorder per location
		 */
		backorderedTotal() {
			let bo_total = 0;
            const bo_items = this.cart.filter(item => {
                if (this.currentlocationid === this.getDefaultLocationDetails.defaultlocationid) {
                    return (item.locationid === undefined || item.locationid === this.currentlocationid) && item.backorder;
                } else {
                    return (item.locationid === this.currentlocationid) && item.backorder;
                }
            });

			if (bo_items.length > 0){
				bo_items.forEach(i => {
					bo_total += i.linetotal;
				});
			}
			return this.toUSD(bo_total);
        },

		/**
		 * return Units/Qty of backorder per location
		 */
		backorderedQty() {
			let bo_qty = 0;
            const bo_items = this.cart.filter(item => {
                if (this.currentlocationid === this.getDefaultLocationDetails.defaultlocationid) {
                    return (item.locationid === undefined || item.locationid === this.currentlocationid) && item.backorder;
                } else {
                    return (item.locationid === this.currentlocationid) && item.backorder;
                }
            });

			if (bo_items.length > 0){
				bo_items.forEach(i => {
					bo_qty += i.quantity;
				});
			}
			return bo_qty;
        },

		classBOContentClass(){
			if (this.showBO)
				return 'filter--closed filter--opened';
			else
				return 'filter--closed';
		},

		totalItems () {
			const items = this.cart.filter(item => (item.locationid === this.currentlocationid));
			// console.log('total items = ' + items.length);
			return items.length;
		}
    },
	methods: {
		
		changeNotes() {
			this.$store.dispatch('cart/set_order_notes', {
				'order_notes' : this.ordernotes
			});
		},
		
		/** update shipping rate
		 * calculate the new totals
		 * calculate totals
		 */
		upShippingRate(e){
			this.$store.dispatch("cart/updateCartCarrier", {
				location: this.currentlocationid,
				carrier: this.shippingcarrier
			});

			const customerIndicator = this.customerIndicator;
			const SRT_VAL = this.storefrontAttributes.find(attr => (attr.type === 'SRT' && attr.indicator == customerIndicator)).value;

			if (SRT_VAL == 'FLAT') {
				this.shipping_rate = e.target.options.item(e.target.options.selectedIndex).getAttribute('rate');
				// console.log(this.shipping_rate);
				this.totals[0].shippingtotal = parseFloat(this.shipping_rate);
				this.totals[0].ordertotal = parseFloat(this.totals[0].ordertotal) + parseFloat(this.shipping_rate);

				this.$store.dispatch("cart/totals", this.totals[0]);
				this.$store.dispatch("cart/calculateTotals");
			}
		}
	},
	watch: {
		defaultcarrier(newVal) {
			console.log('newVal = ' + newVal);
			if (newVal != '' && this.shippingcarrier === '') {
				this.shippingcarrier = newVal;

				const customerIndicator = this.customerIndicator;
				const SRT_VAL = this.storefrontAttributes.find(attr => (attr.type === 'SRT' && attr.indicator == customerIndicator)).value;

				if (SRT_VAL == 'FLAT') {
					this.shipping_rate = this.carrierlist.find(i => i.carriercode == newVal).carrier_rate;
					// console.log(this.shipping_rate);
					this.totals[0].shippingtotal = parseFloat(this.shipping_rate);
					this.totals[0].ordertotal = parseFloat(this.totals[0].ordertotal) + parseFloat(this.shipping_rate);

					this.$store.dispatch("cart/totals", this.totals[0]);
					this.$store.dispatch("cart/calculateTotals");
				}
			}
		}
	},
    
	mounted() {
		this.shippingcarrier = '', this.shippingname = '', this.shippingaddress = '', this.shippingstate = '', this.shippingzip = '', this.ordernotes = '';
		// this.getCarriers();
	},

	created() {
		console.log('this.shippingcarrier  = ' + this.shippingcarrier);
	}
}
</script>
